import { Reveal } from "./motion";
import { ADD_TO_DISCORD_URL } from "./constants";
import { DiscordMark } from "../components/DiscordMark";

export function Footer() {
  return (
    <footer className="relative mx-auto max-w-6xl px-5 pb-20 pt-8">
      <Reveal>
        <div className="lp-panel relative overflow-hidden px-6 py-16 text-center sm:px-12">
          {/* faint glow wash behind the final CTA */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "radial-gradient(60% 120% at 50% 0%, rgba(88,101,242,0.22), transparent 70%)",
            }}
          />
          <div className="relative">
            <h2 className="lp-pixel mx-auto max-w-[20ch] text-[1.5rem] leading-tight text-text-primary sm:text-[2.2rem]">
              READY <span className="lp-neon">PLAYER</span>{" "}
              <span className="lp-neon-blurple">ONE?</span>
            </h2>
            <p
              className="lp-term mx-auto mt-4 max-w-[40ch] text-[1.3rem]"
              style={{ color: "var(--crt-ink-dim)" }}
            >
              Drop it into a voice call and the arcade opens.
            </p>
            <a
              href={ADD_TO_DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="lp-cta mt-9 text-base sm:text-lg"
            >
              <DiscordMark size={20} /> Add to Discord
            </a>
          </div>
        </div>
      </Reveal>

      <div className="mt-12 flex flex-col items-center gap-3 text-center">
        <a
          href="https://goatsquadstudios.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center opacity-90 transition-opacity hover:opacity-100"
          aria-label="Made by Goat Squad Studios"
        >
          <img
            src="/brand/logo-white.svg"
            alt="Goat Squad Studios"
            className="h-12 w-auto sm:h-16"
            width={343}
            height={64}
          />
        </a>
        <p className="lp-term text-[1.1rem]" style={{ color: "var(--crt-ink-muted)" }}>
          Bring your own game files.
        </p>
      </div>
    </footer>
  );
}
